import React, { useEffect, useState } from "react";
import "./orderAnalytics.css";
import { OrderTile } from "../../components/orderTile/orderTile";
import Grid from "@mui/material/Grid";
import { getMetaDataConfig } from '../../services/uiConfigService';
import { Skeleton } from '@mui/material';
import { getData, getDatesForLastMonth, getDatesForPTD } from './orderAnalyticsServices';
import { Loader } from "../../components/loader/Loader";
import { findCurrentMonthCountAndValue, findLastMonthCountAndValue, findLastWeekCountAndValue, findTodayCountAndValue, getSaleslensData, sumCountsInRange } from "../../services/analyticsService";

interface OrderAnalyticsProps {
  coeAPI?: Boolean; 
  type?: string;
}
export function OrderAnalytics({ coeAPI,type }: OrderAnalyticsProps) {

  const [isPeriod, setPeriod] = useState<boolean>(false);
  const [isAPICall, setAPICall] = useState<boolean>(true);
  const [fetchFromSaleslens, setFetchFromSaleslens] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const [orderToday, setOrderToday] = useState<string>("0");
  const [orderLastWeek, setOrderLastWeek] = useState<string>("0");
  const [orderCurrentMonth, setOrderCurrentMonth] = useState<string>("0");
  const [orderLastMonth, setOrderLastMonth] = useState<string>("0");
  const [orderValueToday, setOrderValueToday] = useState<string>("0");
  const [orderValueLastWeek, setOrderValueLastWeek] = useState<string>("0");
  const [orderValueCurrentMonth, setOrderValueCurrentMonth] = useState<string>("0");
  const [orderValueLastMonth, setOrderValueLastMonth] = useState<string>("0");

  const getPortalConfig = async () => {
    setLoading(true);
    try {
      const portalConfig: Record<string, any> = await getMetaDataConfig("clientconfig", "portal_configuration");
      let prd: boolean = false;
      let saleslens: boolean = false;
      if(portalConfig){
      for (const key of portalConfig?.domainValues) {
        if (key?.name === "period") {
          setPeriod(key?.value);
          prd = key?.value;
        }
        if(key?.name === "fetchFromSaleslens"){
          setFetchFromSaleslens(key?.value)
          saleslens = key?.value;
          setAPICall(!key?.value);
        }
      };
      }
      let currentPeriodData:any= { count: 0, value: 0 };
      let lastPeriodData:any= { count: 0, value: 0 };
      if(saleslens){
        const perioddate=await getDatesForPTD()
        const periodStartDate=perioddate.data.features[0]?.startDate
        const periodEndDate=perioddate.data.features[0]?.endDate
        const lastPerioddate=await getDatesForLastMonth()
        const lastPeriodStartDate=lastPerioddate.data.features[0]?.startDate
        const lastPeriodEndDate=lastPerioddate.data.features[0]?.endDate
        const saleslensData: Record<string, any> = await getSaleslensData(coeAPI,type);
        // console.log("saleslensData",saleslensData)
        if(saleslensData){
          const todayData = findTodayCountAndValue(saleslensData);
          const lastWeekData = findLastWeekCountAndValue(saleslensData);
          const lastMonthData = findLastMonthCountAndValue(saleslensData,coeAPI);
          const currentMonthData = findCurrentMonthCountAndValue(saleslensData,coeAPI);
          currentPeriodData = sumCountsInRange(saleslensData, periodStartDate, periodEndDate);
          lastPeriodData = sumCountsInRange(saleslensData, lastPeriodStartDate, lastPeriodEndDate);
          // console.log("today", todayData, 
          //             "Last week", lastWeekData, 
          //             "Last month", lastMonthData, 
          //             "Current Month", currentMonthData, 
          //             "Current Period", currentPeriodData, 
          //             "Last Period", lastPeriodData);
          setOrderToday(todayData?.count);
          setOrderValueToday(parseFloat(todayData?.value).toFixed(2));
          setOrderLastWeek(lastWeekData?.count);
          setOrderValueLastWeek(parseFloat(lastWeekData?.value).toFixed(2));
          setOrderCurrentMonth(currentMonthData?.count);
          setOrderLastMonth(lastMonthData?.count);
          setOrderValueCurrentMonth(parseFloat(currentMonthData?.value).toFixed(2));
          setOrderValueLastMonth(parseFloat(lastMonthData?.value).toFixed(2)); 
        }
      }
      if (prd) {
        if(saleslens){
          setOrderCurrentMonth(currentPeriodData?.count);
          setOrderLastMonth(lastPeriodData?.count);
          setOrderValueCurrentMonth(parseFloat(currentPeriodData?.value).toFixed(2));
          setOrderValueLastMonth(parseFloat(lastPeriodData?.value).toFixed(2));
          setAPICall(false);
          setLoading(false);

        }else{
          const response: Record<string, any> = await getData();
          setOrderToday(response.orderValueToday);
          setOrderLastWeek(response.orderValueLastWeek);
  
          setOrderCurrentMonth(response.orderValueCurrentMonth);
          setOrderLastMonth(response.orderValueLastMonth);
  
          setOrderValueToday(response.orderToday);
          setOrderValueLastWeek(response.orderLastWeek);
  
          setOrderValueCurrentMonth(response.orderCurrentMonth);
          setOrderValueLastMonth(response.orderLastMonth);
          setAPICall(false);
          setLoading(false);

        }
      }
            
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    getPortalConfig();
  }, []);

  return (
    <div className="box-container">
      {
        loading ? <Loader /> :
          <div className="tile-container">
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                 fetchFromSaleslens={fetchFromSaleslens}
                  heading={"ORDER COUNT"}
                  subHeading={"Today"}
                  footerHeading={"Last Week"}
                  img={"analyticsOrderIcon"}
                  callApi={isAPICall}
                  api={"/v1/query/orderCountToday"}
                  api2={"/v1/query/orderCountWeek"}
                  orderPrimaryValue={orderToday}
                  orderSecondaryValue={orderLastWeek}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                 fetchFromSaleslens={fetchFromSaleslens}
                  heading={isPeriod ? "PTD ORDER COUNT" : "MTD ORDER COUNT"}
                  subHeading={isPeriod ? "Current Period" : "Current Month"}
                  footerHeading={isPeriod ? "Last Period" : "Last Month"}
                  img={"analyticsMtdIcon"}
                  callApi={isAPICall}
                  api={"/v1/query/orderCountMonth"}
                  api2={"/v1/query/orderCountLastMonth"}
                  orderPrimaryValue={orderCurrentMonth}
                  orderSecondaryValue={orderLastMonth}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                 fetchFromSaleslens={fetchFromSaleslens}
                  heading={"ORDER VALUE"}
                  subHeading={"Today"}
                  footerHeading={"Last Week"}
                  img={"analyticsOrderValueIcon"}
                  callApi={isAPICall}
                  api={"/v1/query/orderValueToday"}
                  api2={"/v1/query/orderValueWeek"}
                  orderPrimaryValue={orderValueToday}
                  orderSecondaryValue={orderValueLastWeek}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                 fetchFromSaleslens={fetchFromSaleslens}
                  heading={isPeriod ? "PTD ORDER VALUE" : "MTD ORDER VALUE"}
                  subHeading={isPeriod ? "Current Period" : "Current Month"}
                  footerHeading={isPeriod ? "Last Period" : "Last Month"}
                  img={"analyticsMtdIcon"}
                  callApi={isAPICall}
                  api={"/v1/query/orderAmountMonth"}
                  api2={"/v1/query/orderAmountLastMonth"}
                  orderPrimaryValue={orderValueCurrentMonth}
                  orderSecondaryValue={orderValueLastMonth}
                />
              </Grid>
            </Grid>
          </div>
      }
    </div>
  );
}